export enum WhoOptionsNonAdult {
    Patient_Weight = 1,
    Drug_dosage_calculations_based_on_patient_weight = 2,
    Specific_airway_management = 3,
    Parent_or_guardian_aware_of_risks_and_estimated_time_of_discharge_to_the_ward = 4
}
